import React from 'react'
import { withTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
import hammerIcon from '../../assets/images/Google puzzle@2x.png'
import pinIcon from '../../assets/images/Google pin@2x.png'
import inactiveIcon from '../../assets/images/chirpyest-disabled-32x32.png'
import { styles } from '../popups/styles'
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import { detect } from 'detect-browser'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { BREAKPOINTS } from '../../constants'

const style = (theme: Theme) =>
  createStyles({
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.common.black,
    },
  })

export interface DialogTitleProps extends WithStyles<typeof style> {
  id: string
  children: React.ReactNode
  onClose: () => void
}

const DialogTitle = withStyles(style)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props
  return (
    <MuiDialogTitle disableTypography {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose && (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      )}
    </MuiDialogTitle>
  )
})

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))(MuiDialogContent)

interface PopOutProps {
  t: TFunction
  open: boolean
  handleClose: any
}

const PinExtensionReminderPopOut = ({ t, open, handleClose }: PopOutProps) => {
  const classes = styles()
  const browser = detect()
  const isChrome = browser?.name === 'chrome'
  const isDesktop = useMediaQuery(`@media (min-width: ${BREAKPOINTS.lg}px)`)
  const popExtPinReminder = isChrome && isDesktop

  return (
    <Dialog
      scroll="paper"
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={popExtPinReminder && open}
      className={classes.popout}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        {' '}
      </DialogTitle>
      <DialogContent>
        <div className={classes.pinExtensionDialog}>
          <div className={classes.popOutText}>
            {t('popUps.text.keepTheChirpyest')}{' '}
            <img
              src={inactiveIcon}
              alt={t('imageAlts.inactive')}
              className={classes.extension}
            />{' '}
            {t('popUps.text.visible')}{' '}
          </div>
          <div className={classes.popOutText}>
            {t('popUps.text.clickThis')}{' '}
            <img
              src={hammerIcon}
              alt={t('imageAlts.hammer')}
              className={classes.icon}
            />{' '}
            {t('popUps.text.thenClick')}{' '}
            <img
              src={pinIcon}
              alt={t('imageAlts.pin')}
              className={classes.icon}
            />{' '}
            {t('popUps.text.pinExtension')}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default withTranslation()(PinExtensionReminderPopOut)
